{
  "commonHeader": {
    "upgradeToPro": "Nâng cấp",
    "learnMore": "Tìm hiểu thêm",
    "AIProductivitySuite": {
      "title": "Bộ công cụ năng suất AI",
      "desc": "Biến những cuộc thảo luận đầy cảm hứng thành sản phẩm ấn tượng."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Quản lý tài khoản tổ chức của bạn bằng AI",
        "description": "Nhận câu trả lời thông minh cho các câu hỏi về tài khoản và trợ giúp điều hướng cài đặt.",
        "terms": "Bằng việc sử dụng các tính năng beta của Zoom, bạn đồng ý với {0}",
        "termsText": "Điều khoản Chương trình Beta của Zoom"
      },
      "diveDeeper": "Tìm hiểu sâu hơn",
      "shareFeedback": "Chia sẻ phản hồi trong {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Hỏi về tài khoản của tổ chức bạn",
      "heroInvite": "Làm cách nào để mời người dùng mới vào tài khoản của tôi?",
      "heroGroups": "Làm cách nào để gán người dùng vào nhóm?",
      "heroRoles": "Làm cách nào để quản lý vai trò và quyền?"
    },
    "backMainAccount": "Quay lại tài khoản chính",
    "discoverProducts": "Khám phá sản phẩm",
    "pricing": "Giá",
    "more": "Thêm",
    "sidebarExpanded": "đã mở rộng",
    "sidebarCollapsed": "đã thu gọn",
    "search": "Tìm kiếm",
    "users": "Người dùng",
    "settings": "Cài đặt tài khoản",
    "navigation": "Điều hướng",
    "clear": "Xóa",
    "searchPlaceholderAll": "Tìm người dùng, cài đặt tài khoản hoặc điều hướng",
    "searchPlaceholderUsers": "Tìm người dùng hoặc điều hướng",
    "searchPlaceholderSettings": "Tìm cài đặt tài khoản hoặc điều hướng",
    "searchPlaceholderNav": "Tìm điều hướng",
    "searchGuide": "Nhập từ khóa để bắt đầu tìm kiếm",
    "installOnDesktop": "Cài đặt trên máy tính",
    "downloadCenter": "Trung tâm tải xuống",
    "getInTouch": "Liên hệ với chúng tôi",
    "featuredProduct": "sản phẩm nổi bật",
    "logo": {
      "adminCenter": "Trung tâm quản trị",
      "subAccount": "Đang quản lý tài khoản phụ",
      "externalAccount": "Đang quản lý tài khoản được ủy quyền"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Tìm hiểu thêm",
      "gotIt": "Đã hiểu"
    },
    "coachMark": {
      "dvsTipsTitle": "Phân khu hiện đã có sẵn",
      "dvsTipsContent": "Phân khu được dùng để tạo nhiều phiên bản của một số sản phẩm Zoom trong tài khoản của bạn."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Tìm hiểu thêm",
      "gotIt": "Đã hiểu"
    },
    "coachMark": {
      "extAccountTipsTitle": "Quản lý tài khoản bên ngoài",
      "extAccountTipsContent": "Cần quản lý tài khoản khác? Chỉ cần gửi yêu cầu—sau khi họ phê duyệt, bạn sẽ có quyền truy cập!"
    }
  },
  "feedback": {
    "dialogTitle": "Gửi phản hồi",
    "itemLableForProductArea": "Khu vực sản phẩm",
    "itemLableForSatisfied": "Bạn hài lòng với trải nghiệm của mình ở mức độ nào?",
    "dissatisfied": "Rất không hài lòng",
    "satisfied": "Rất hài lòng",
    "itemLableForFeedback": "Phản hồi",
    "placeholder": "Cảm ơn ý tưởng, ý kiến và đề xuất của bạn.",
    "btnCancel": "Hủy",
    "btnSubmit": "Gửi",
    "supportTips": "Để được hỗ trợ kỹ thuật, vui lòng truy cập",
    "btnSupport": "Hỗ trợ.",
    "messages": {
      "success": "Xin cảm ơn sự phản hồi của bạn!",
      "productFailed": "Khu vực sản phẩm là bắt buộc.",
      "scoreFailed": "Điểm hài lòng là bắt buộc."
    },
    "products": {
      "General": "Chung",
      "AI": "AI",
      "Apps": "Ứng dụng",
      "Calendar": "Lịch",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Thư",
      "Meetings": "Cuộc họp",
      "Notes": "Ghi chú",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Trình lên lịch",
      "Tasks": "Tác vụ",
      "TeamChat": "Trò chuyện nhóm",
      "WebinarsAndEvents": "Hội thảo trên web và sự kiện",
      "Whiteboard": "Bảng trắng",
      "WorkflowAutomations": "Tự động hóa quy trình làm việc",
      "WorkspaceReservation": "Đặt chỗ không gian làm việc",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Miễn trừ trách nhiệm này được tạo bởi quản trị viên tài khoản của bạn.",
    "cancel": "Hủy",
    "agree": "Đồng ý"
  },
  "shared": {
    "sideMenu": {
      "personal": "Cá nhân",
      "admin": "Quản trị viên",
      "menu": "Menu",
      "pinned": "Đã ghim",
      "pin": "Ghim",
      "unpin": "Bỏ ghim",
      "moveItem": "Di chuyển mục",
      "myAccount": "Tài khoản của tôi",
      "upgradeToPro": "Nâng cấp lên Pro",
      "grabbedKeyboard": "Đã nắm {0}. Dùng phím mũi tên lên và xuống để di chuyển, phím cách hoặc Enter để thả.",
      "dropped": "Đã thả {0}.",
      "releasedUnchanged": "Đã thả {0}, vị trí không thay đổi.",
      "movedToPosition": "{0} đã được chuyển đến vị trí {1}/{2}.",
      "movedUp": "{0} đã được chuyển lên, vị trí {1}/{2}.",
      "movedDown": "{0} đã được chuyển xuống, vị trí {1}/{2}.",
      "movedUpNew": "{0} đã được chuyển lên, vị trí mới {1}/{2}",
      "movedDownNew": "{0} đã được chuyển xuống, vị trí mới {1}/{2}",
      "cannotMoveFurther": "Không thể di chuyển {0} thêm.",
      "grabbedMouse": "Đã nắm {0}. Di chuyển chuột để đổi vị trí, nhấp để thả, nhấn Escape để hủy."
    },
    "item": "Mục",
    "gotIt": "Đã hiểu",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Đã thêm số điện thoại thành công! Giờ đây, bạn có thể sử dụng số điện thoại này để đăng nhập và khôi phục tài khoản trong tương lai.",
    "mfa_to_signin_phone_success": "{phone} hiện là số điện thoại đăng nhập cho {email}.",
    "login_passkey_bound_success": "Đã tạo thành công khoá truy cập"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Các tính năng quản lý nâng cao sau đây sẽ chỉ áp dụng cho người dùng cộng tác và được cấp giấy phép",
      "licensed_basic": "Các tính năng quản lý nâng cao sau đây sẽ chỉ áp dụng cho người dùng cơ bản và được cấp giấy phép",
      "licensed": "Các tính năng quản lý nâng cao sau đây sẽ chỉ áp dụng cho người dùng được cấp giấy phép"
    },
    "support": "- Hỗ trợ cài đặt tài khoản và cài đặt nhóm người dùng",
    "archive_product": {
      "title": "Lưu trữ cuộc họp và hội thảo trực tuyến",
      "detail": "- Các cuộc họp sẽ được lưu trữ khi người dùng trong tài khoản của bạn tham gia. Để sử dụng cài đặt này, hãy cài đặt một <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">ứng dụng lưu trữ</a> từ Zoom App Marketplace."
    },
    "restrict": {
      "title": "Hạn chế người dùng sử dụng các tính năng đã chọn khi tham gia cuộc họp",
      "detail": "- Không thể sử dụng tính năng đã chọn dù người chủ trì cuộc họp đã bật tính năng này cho cuộc họp."
    },
    "meeting_integration": {
      "title": "Bật tích hợp DLP (Phòng chống thất thoát dữ liệu) cho trò chuyện trong cuộc họp",
      "detail": "- Sau khi bật, DLP sẽ áp dụng cho cả tin nhắn trong cuộc trò chuyện riêng tư và công khai do người tham gia gửi. Tin nhắn sẽ bị xóa ngay lập tức nếu người tham gia cuộc họp (nội bộ/bên ngoài) đang trò chuyện và tin nhắn đi ngược lại chính sách tuân thủ của tổ chức chủ trì."
    },
    "chat_tool": {
      "title": "Công cụ phương thức trò chuyện",
      "detail": "- Xác định các từ khóa và mẫu văn bản đã xác định trong nội dung được chia sẻ và ngăn người dùng chia sẻ tin nhắn ngoài ý muốn"
    },
    "information_barriers": {
      "title": "Rào cản thông tin",
      "detail": "- Rào cản thông tin điều khiển thông tin liên lạc giữa những người dùng nhất định vì mục đích tuân thủ. Có thể đặt ra các giới hạn sử dụng một số tính năng cụ thể trong cuộc họp và trò chuyện (trò chuyện trong cuộc họp, chia sẻ màn hình và truyền tệp) cho những người dùng trong hai nhóm và đối với một số người dùng nhất định. Các giới hạn này bảo vệ thông tin mật để tránh bị trao đổi giữa những người dùng trái phép."
    },
    "dashboard": {
      "title": "Bảng điều khiển",
      "detail": "- Đối với cuộc họp > bảng điều khiển cuộc họp trước đây, một số người dùng sẽ chỉ nhìn thấy dữ liệu trong vòng 3 tháng"
    },
    "reports": {
      "title": "Các báo cáo",
      "detail": "- Một số báo cáo người dùng chỉ hiển thị dữ liệu trong 3 tháng cho một số người dùng: báo cáo từ chối trách nhiệm, báo cáo nhật ký người dự thính, báo cáo nhật ký hoạt động của quản trị viên và báo cáo đăng nhập/đăng xuất"
    },
    "close": "Đóng"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "Gói {planName} của bạn sẽ bị hủy vào ngày {cancelDate}. Trước ngày đó, bạn có thể kích hoạt lại giấy phép hội thảo trực tuyến của mình. Từ {supportStartDate} - {supportEndDate}, bạn có thể liên hệ với bộ phận Hỗ trợ khách hàng để lấy dữ liệu của hội thảo trực tuyến hiện có. Sau {dataLossDate}, bạn sẽ mất tất cả dữ liệu của hội thảo trực tuyến.",
            "nonAdmin": "Gói {planName} của bạn sẽ bị hủy vào ngày {cancelDate}. Từ giờ cho đến ngày đó, bạn có thể liên hệ quản trị viên tài khoản để kích hoạt lại giấy phép hội thảo trực tuyến của mình. Từ {supportStartDate} - {supportEndDate}, bạn có thể liên hệ với bộ phận Hỗ trợ khách hàng để lấy dữ liệu của hội thảo trực tuyến hiện có. Sau {dataLossDate}, bạn sẽ mất tất cả dữ liệu hội thảo trực tuyến của tài khoản của mình."
          },
          "admin": "Gói {planName} của bạn sẽ bị hủy vào ngày {cancelDate}. Từ giờ cho đến ngày đó, bạn có thể kích hoạt lại giấy phép hội thảo trực tuyến của mình. Từ {supportStartDate} - {supportEndDate}, bạn có thể liên hệ với bộ phận Hỗ trợ khách hàng để lấy {supportContent} của hội thảo trực tuyến hiện có. Sau {dataLossDate}, bạn sẽ mất tất cả dữ liệu của hội thảo trực tuyến của tài khoản của mình.",
          "nonAdmin": "Gói {planName} của bạn sẽ bị hủy vào ngày {cancelDate}. Từ giờ cho đến ngày đó, bạn có thể liên hệ quản trị viên tài khoản để kích hoạt lại giấy phép hội thảo trực tuyến của mình. Từ {supportStartDate} - {supportEndDate}, bạn có thể liên hệ với bộ phận Hỗ trợ khách hàng để lấy {supportContent} của hội thảo trực tuyến hiện có. Sau {dataLossDate}, bạn sẽ mất tất cả dữ liệu của hội thảo trực tuyến của tài khoản của mình."
        },
        "expired": {
          "admin": "Gói {planName} của bạn đã bị hủy. Từ {supportStartDate} - {supportEndDate}, bạn có thể liên hệ với bộ phận Hỗ trợ khách hàng để lấy {supportContent} của hội thảo trực tuyến hiện có, hoặc mua lại Zoom Webinars để khôi phục quyền truy cập dữ liệu. Sau {dataLossDate}, bạn sẽ mất tất cả dữ liệu hội thảo trực tuyến của tài khoản của mình.",
          "nonAdmin": "Gói {planName} của bạn đã bị hủy. Từ {supportStartDate} - {supportEndDate}, bạn có thể liên hệ với bộ phận Hỗ trợ khách hàng để lấy {supportContent} của hội thảo trực tuyến hiện có, hoặc liên hệ với quản trị viên tài khoản để mua lại Zoom Webinars để khôi phục quyền truy cập dữ liệu. Sau {dataLossDate}, bạn sẽ mất tất cả dữ liệu hội thảo trực tuyến của tài khoản của mình."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "Gói {planName} của bạn sẽ bị tạm dừng vào {pausedDate} trong {pauseDuration}. Trong thời gian tạm dừng, bạn chỉ có thể xem các hội thảo trực tuyến hiện có và tài nguyên của chúng. Bạn có thể hủy tạm dừng và tiếp tục gói đăng ký giấy phép hội thảo trực tuyến bất kỳ lúc nào.",
            "nonAdmin": "Gói {planName} của bạn sẽ bị tạm dừng vào {pausedDate} trong {pauseDuration}. Trong thời gian tạm dừng, bạn chỉ có thể xem các hội thảo trực tuyến hiện có và tài nguyên của chúng. Bạn có thể liên hệ với quản trị viên tài khoản của mình để hủy tạm dừng và tiếp tục gói đăng ký giấy phép hội thảo trực tuyến bất cứ lúc nào."
          },
          "admin": "Gói {planName} của bạn sẽ bị tạm dừng vào {pausedDate} trong {pauseDuration}. Trong thời gian tạm dừng, bạn chỉ có thể xem {supportContent}. Bạn có thể hủy tạm dừng và tiếp tục gói đăng ký giấy phép hội thảo trực tuyến bất kỳ lúc nào.",
          "nonAdmin": "Gói {planName} của bạn sẽ bị tạm dừng vào {pausedDate} trong {pauseDuration}. Trong thời gian tạm dừng, bạn chỉ có thể xem {supportContent}. Bạn có thể liên hệ với quản trị viên tài khoản của mình để hủy tạm dừng và tiếp tục gói đăng ký giấy phép hội thảo trực tuyến bất cứ lúc nào."
        },
        "active": {
          "webinars": {
            "admin": "{planName} của bạn đã tạm dừng trong {pauseDuration} bắt đầu từ {pausedDate}. Trong lúc tạm dừng, bạn chỉ có thể xem các hội thảo trực tuyến hiện có. Bạn có thể tiếp tục gói đăng ký giấy phép hội thảo trực tuyến bất cứ lúc nào.",
            "nonAdmin": "{planName} của bạn đã tạm dừng trong {pauseDuration} bắt đầu từ {pausedDate}. Trong lúc tạm dừng, bạn chỉ có thể xem các hội thảo trực tuyến hiện có. Vui lòng liên hệ với quản trị viên tài khoản của bạn để tiếp tục gói đăng ký giấy phép hội thảo trực tuyến bất kỳ lúc nào."
          },
          "admin": "{planName} của bạn đã tạm dừng trong {pauseDuration}. Trong thời gian tạm dừng, bạn chỉ có thể xem {supportContent} của các hội thảo trực tuyến hiện có. Bạn có thể tiếp tục gói đăng ký giấy phép hội thảo trực tuyến bất cứ lúc nào.",
          "nonAdmin": "{planName} của bạn đã tạm dừng trong {pauseDuration}. Trong thời gian tạm dừng, bạn chỉ có thể xem {supportContent} của các hội thảo trực tuyến hiện có. Vui lòng liên hệ với quản trị viên tài khoản của bạn để tiếp tục gói đăng ký giấy phép hội thảo trực tuyến bất kỳ lúc nào."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Giấy phép {planName} của bạn sẽ bị tạm dừng vào {pausedDate} trong {pauseDuration}. Để tiếp tục chủ trì hội thảo trực tuyến, hãy chỉ định một giấy phép có hiệu lực cho người dùng này trước khi chính thức tạm dừng. Bạn cũng có thể hủy tạm dừng để tiếp tục sử dụng giấy phép này.",
            "nonAdmin": "Giấy phép {planName} của bạn sẽ bị tạm dừng vào {pausedDate} trong {pauseDuration}. Trong thời gian tạm dừng, bạn chỉ có thể xem các hội thảo trực tuyến hiện tại và tài nguyên tương ứng. Để tiếp tục tổ chức hội thảo trực tuyến, vui lòng liên hệ với quản trị viên tài khoản của bạn để chỉ định giấy phép có hiệu lực cho tài khoản của bạn trước khi chính thức tạm dừng."
          },
          "active": {
            "admin": "Giấy phép {planName} của bạn đã tạm dừng trong {pauseDuration} kể từ {pausedDate}. Trong thời gian tạm dừng, bạn chỉ có thể xem các hội thảo trực tuyến hiện có. Bạn có thể tiếp tục gói đăng ký giấy phép hoặc chỉ định giấy phép có hiệu lực cho tài khoản của bạn để tiếp tục chủ trì hội thảo trực tuyến.",
            "nonAdmin": "Giấy phép {planName} của bạn đã tạm dừng trong {pauseDuration} kể từ {pausedDate}. Trong thời gian tạm dừng, bạn chỉ có thể xem các hội thảo trực tuyến hiện có. Để chủ trì hội thảo trực tuyến trong thời gian tạm dừng, vui lòng liên hệ với quản trị viên tài khoản của bạn để chỉ định giấy phép có hiệu lực cho tài khoản của bạn."
          }
        },
        "cancel": {
          "active": {
            "admin": "Giấy phép {planName} của bạn sẽ bị hủy vào ngày {cancelDate}. Để tiếp tục tổ chức hội thảo trực tuyến, vui lòng kích hoạt lại giấy phép hội thảo trực tuyến hoặc gán giấy phép đang hoạt động trước khi việc hủy có hiệu lực. Nếu không thực hiện hành động nào, bạn sẽ có thời gian ân hạn từ {supportStartDate} - {supportEndDate} để liên hệ bộ phận Hỗ trợ khách hàng nhằm lấy dữ liệu hội thảo trực tuyến hiện có. Sau {dataLossDate}, tất cả dữ liệu hội thảo trực tuyến liên kết với tài khoản của bạn sẽ bị xóa vĩnh viễn.",
            "nonAdmin": "Giấy phép {planName} của bạn sẽ bị hủy vào ngày {cancelDate}. Để tiếp tục tổ chức hội thảo trực tuyến, vui lòng liên hệ quản trị viên tài khoản để kích hoạt lại giấy phép hội thảo trực tuyến hoặc gán giấy phép đang hoạt động trước khi việc hủy có hiệu lực. Nếu không thực hiện hành động nào, bạn sẽ có thời gian ân hạn từ {supportStartDate} - {supportEndDate} để liên hệ bộ phận Hỗ trợ khách hàng nhằm lấy dữ liệu hội thảo trực tuyến hiện có. Sau {dataLossDate}, tất cả dữ liệu hội thảo trực tuyến liên kết với tài khoản của bạn sẽ bị xóa vĩnh viễn."
          },
          "expired": {
            "admin": "Giấy phép {planName} của bạn đã bị hủy. Để tiếp tục chủ trì hội thảo trực tuyến, hãy chỉ định một giấy phép có hiệu lực cho người dùng này. Từ {supportStartDate} - {supportEndDate}, bạn có thể liên hệ với bộ phận Hỗ trợ khách hàng để lấy dữ liệu hội thảo trực tuyến hiện có.",
            "nonAdmin": "Giấy phép {planName} của bạn đã bị hủy. Để tiếp tục chủ trì hội thảo trực tuyến, vui lòng liên hệ với quản trị viên tài khoản của bạn để chỉ định giấy phép có hiệu lực cho hồ sơ của bạn. Từ {supportStartDate} - {supportEndDate}, hãy liên hệ với bộ phận Hỗ trợ khách hàng để lấy dữ liệu hội thảo trực tuyến hiện tại."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Giấy phép {planName} của bạn sẽ bị tạm dừng vào {pausedDate} trong {pauseDuration}. Trong thời gian tạm dừng, bạn chỉ có thể xem {supportContent} của các hội thảo trực tuyến trước đó. Để tiếp tục truy cập tài nguyên của hội thảo trực tuyến, hãy chỉ định giấy phép có hiệu lực cho người dùng này trước khi việc chính thức tạm dừng. Bạn cũng có thể hủy tạm dừng để tiếp tục sử dụng giấy phép này.",
              "nonAdmin": "Giấy phép {planName} của bạn sẽ bị tạm dừng vào {pausedDate} trong {pauseDuration}. Trong thời gian tạm dừng, bạn chỉ có thể xem {supportContent}. Để tiếp tục truy cập tài nguyên của hội thảo trực tuyến, vui lòng liên hệ với quản trị viên tài khoản của bạn để chỉ định giấy phép có hiệu lực cho hồ sơ của bạn."
            },
            "active": {
              "admin": "{planName} của bạn đã tạm dừng trong {pauseDuration} kể từ {pausedDate}. Trong thời gian tạm dừng, bạn chỉ có thể xem {supportContent} của các hội thảo trực tuyến hiện tại. Để tiếp tục truy cập tài nguyên của các hội thảo trực tuyến, vui lòng chỉ định giấy phép có hiệu lực cho tài khoản của bạn. Bạn cũng có thể tiếp tục gói đăng ký giấy phép này bất cứ lúc nào.",
              "nonAdmin": "{planName} của bạn đã tạm dừng trong {pauseDuration} kể từ {pausedDate}. Trong thời gian tạm dừng, bạn chỉ có thể xem {supportContent} của các hội thảo trực tuyến hiện tại. Để chủ trì hội thảo trực tuyến trong thời gian tạm dừng, vui lòng liên hệ với quản trị viên tài khoản của bạn để chỉ định giấy phép có hiệu lực cho tài khoản của bạn."
            }
          },
          "cancel": {
            "active": {
              "admin": "Gói {planName} của bạn sẽ bị hủy vào ngày {cancelDate}. Để tiếp tục chủ trì hội thảo trực tuyến, vui lòng chỉ định giấy phép có hiệu lực cho tài khoản của bạn trước khi chính thức hủy. Bạn có thể kích hoạt lại giấy phép này trước {cancelDate}. Từ {supportStartDate} - {supportEndDate}, bạn có thể liên hệ với bộ phận Hỗ trợ khách hàng để lấy {supportContent} của hội thảo trực tuyến hiện tại.",
              "nonAdmin": "Giấy phép {planName} của bạn sẽ bị hủy vào ngày {cancelDate}. Để tiếp tục tổ chức hội thảo trực tuyến, vui lòng liên hệ quản trị viên tài khoản để kích hoạt lại giấy phép hội thảo trực tuyến hoặc gán giấy phép đang hoạt động trước khi việc hủy có hiệu lực. Nếu không thực hiện hành động nào, bạn sẽ có thời gian ân hạn từ {supportStartDate} - {supportEndDate} để liên hệ bộ phận Hỗ trợ khách hàng nhằm lấy {supportContent} của các hội thảo trực tuyến hiện có. Sau {dataLossDate}, tất cả dữ liệu hội thảo trực tuyến liên kết với tài khoản của bạn sẽ bị xóa vĩnh viễn."
            },
            "expired": {
              "admin": "Giấy phép {planName} của bạn đã bị hủy. Để tiếp tục chủ trì hội thảo trực tuyến, hãy chỉ định một giấy phép có hiệu lực cho người dùng này. Từ {supportStartDate} đến {supportEndDate}, liên hệ với bộ phận Hỗ trợ khách hàng để lấy {supportContent} của hội thảo trực tuyến hiện tại.",
              "nonAdmin": "Giấy phép {planName} của bạn đã bị hủy. Để tiếp tục chủ trì hội thảo trực tuyến, vui lòng liên hệ với quản trị viên tài khoản của bạn để chỉ định giấy phép có hiệu lực cho hồ sơ của bạn. Từ {supportStartDate} đến {supportEndDate}, liên hệ với bộ phận Hỗ trợ khách hàng để lấy {supportContent} của hội thảo trực tuyến hiện tại."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "dữ liệu",
        "recordingsAndTranscripts": "bản ghi và bản chép lời",
        "reports": "báo cáo",
        "summaries": "bản tóm tắt",
        "dashboard": "bảng điều khiển"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "Bản ghi và bản chép lời của các buổi hội thảo trực tuyến trước đây",
          "reports": "báo cáo của các hội thảo trực tuyến trước đây",
          "summaries": "bản tóm tắt của các hội thảo trực tuyến trước đây",
          "dashboard": "bản điều khiển của các hội thảo trực tuyến trước đây",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Kích hoạt lại gói dịch vụ",
    "purchasePlan": "Mua gói",
    "removePause": "Hủy tạm dừng",
    "resumeSubscription": "Tiếp tục gói đăng ký",
    "month": "tháng",
    "months": "tháng",
    "assignLicense": "Chỉ định giấy phép"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Đã hiểu"
    },
    "coachMark": {
      "tipsTitle": "Sổ địa chỉ sẽ trở thành Thư mục khách hàng",
      "tipsContent": "Trong bản phát hành tháng 10 năm 2026, chúng tôi đổi tên Sổ địa chỉ thành Thư mục khách hàng để phản ánh đúng hơn mục đích của tính năng. Tất cả chức năng, quyền và quy trình làm việc hiện có sẽ giữ nguyên—bạn sẽ tiếp tục quản lý danh sách khách hàng (sổ địa chỉ) và danh bạ như hiện tại."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Chúng tôi đang cập nhật các điều khoản và chính sách",
    "agreeSub": "Với việc tiếp tục sử dụng Zoom, bạn chấp nhận <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Điều khoản dịch vụ</a> và <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Chính sách quyền riêng tư được cập nhật</a>.",
    "continue": "Tiếp tục"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Quay lại tài khoản chính",
      "backLinkedAccount": "Quay lại tài khoản được liên kết",
      "backMyAccount": "Quay lại Tài khoản của tôi",
      "myAccount": "Tài khoản của tôi"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion hiện đã có sẵn cho tài khoản của bạn",
      "desc": "Dưới đây là một số tính năng Custom AI Companion mà bạn có thể sử dụng trong tài khoản của mình:",
      "studioTitle": "AI Studio",
      "studioDesc": "Tùy chỉnh trải nghiệm AI Companion cho tổ chức của bạn.",
      "integrationsTitle": "Tích hợp bên thứ ba",
      "integrationsDesc": "Tận dụng các ứng dụng bên thứ ba để hợp lý hóa quy trình làm việc của bạn.",
      "clipsTitle": "Hình đại diện tùy chỉnh cho Zoom Clips",
      "clipsDesc": "Cho phép người dùng cá nhân hóa hình đại diện AI để sử dụng trong các clip của họ."
    },
    "coachMark": {
      "licenseTitle": "Bạn có {0} giấy phép Custom AI Companion cần gán",
      "licenseDesc": "Gán các giấy phép này trong <b>Quản lý người dùng</b> để người dùng của bạn có thể bắt đầu sử dụng các khả năng AI Companion nâng cao.",
      "settingTitle": "Xem cài đặt Custom AI Companion cho tài khoản của bạn",
      "settingDesc": "Cấu hình cài đặt cho từng tính năng Custom AI trong <b>Cài đặt tài khoản</b>. <a href=\"/account/setting?tab=aicompanion\">Đi tới cài đặt</a>",
      "groupSettingTitle": "Xem cài đặt Custom AI cho nhóm của bạn",
      "groupSettingDesc": "Cấu hình cài đặt cho từng tính năng Custom AI trong <b>Cài đặt nhóm</b>. <a href=\"/account/group\">Đi tới cài đặt</a>"
    },
    "common": {
      "learnMore": "Tìm hiểu thêm",
      "quickTour": "Tham quan nhanh",
      "remindLater": "Nhắc tôi sau",
      "dismiss": "Bỏ qua",
      "next": "Tiếp theo",
      "back": "Quay lại",
      "gotIt": "Đã hiểu",
      "goToSetting": "Đi tới cài đặt"
    },
    "aiPanelToast": "Bật cài đặt <b>Bảng AI trong Zoom Workplace</b> để bắt đầu sử dụng tất cả các tính năng Custom AI Companion."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Đã hiểu",
      "next": "Tiếp theo",
      "remindMeLater": "Nhắc tôi sau",
      "waffleMenuTitle": "Chào mừng bạn đến với trải nghiệm web Zoom mới",
      "waffleMenuDesc": "Truy cập các sản phẩm Zoom từ mọi nơi với <b>menu sản phẩm.</b>",
      "profileMenuTitle": "Tài khoản của tôi",
      "profileMenuDesc": "Tìm hồ sơ và cài đặt cá nhân của bạn trong <b>Tài khoản của tôi.</b>",
      "personalTitle": "Truy cập mọi thứ bạn cần",
      "personalDesc": "<b>Tài khoản của tôi</b> bao gồm hồ sơ, cài đặt, bản chép lời cuộc họp và nhiều nội dung khác.",
      "adminCenterTitle": "Tìm cài đặt tổ chức trong Trung tâm quản trị",
      "adminCenterDesc": "<b>Trung tâm quản trị</b> mới cho phép bạn cấu hình sản phẩm và điều chỉnh cài đặt cho toàn bộ tổ chức.",
      "adminMenuForTitle": "Sử dụng Trung tâm quản trị như một chuyên gia",
      "adminMenuForAccountSettings": "<b>Cài đặt</b> cho phép bạn truy cập cài đặt sản phẩm mặc định cho mọi người trong tổ chức.",
      "adminMenuForContentManagementItem": "<b>Quản lý nội dung</b> là nơi bạn có thể quản lý tất cả nội dung do người dùng tạo.",
      "adminMenuForConfigureProductsItem": "<b>Cấu hình sản phẩm</b> cho phép bạn thiết lập và hoàn thành các tác vụ quản trị cho sản phẩm của mình.",
      "adminMenuForNoItems": "Trung tâm quản trị mới giúp bạn truy cập và quản lý cài đặt tài khoản cũng như sản phẩm dễ dàng hơn. Bạn cũng có thể ghim bất kỳ mục nào để truy cập nhanh hơn.",
      "tryNewExperience": "Dùng thử trải nghiệm mới",
      "tryNewExperienceDetail": "Hãy dùng thử! Bạn luôn có thể quay lại trải nghiệm cổ điển này.",
      "tryNewExperienceTitle": "Giao diện mới cho Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Bảo lưu mọi quyền.",
    "terms": "Điều khoản",
    "privacy": "Quyền riêng tư",
    "trust_center": "Trung tâm tin cậy",
    "acceptable_use_guidelines": "Hướng dẫn sử dụng chấp nhận được",
    "legal": "Pháp lý",
    "do_not_sell_my_personal_information": "Lựa chọn quyền riêng tư của bạn",
    "cookie_preferences": "Tùy chọn cookie",
    "pricing": "Gói và giá",
    "feedback": "Phản hồi",
    "contact_us": "Liên hệ với chúng tôi"
  },
  "termChange": {
    "changeTerm": {
      "title": "Thỏa thuận thay đổi thời hạn gia hạn",
      "quoteNumbers": "(Các) biểu mẫu đơn hàng đã sửa đổi - {0}",
      "content1": "Bằng việc chấp nhận các điều khoản này, Khách hàng đồng ý sửa đổi thời hạn gia hạn thuê bao hiện có đối với tất cả Biểu mẫu đơn hàng giữa Zoom Communications, Inc. (“Zoom”) và Khách hàng bằng cách thay đổi thời hạn cam kết từ gia hạn theo tháng sang {0}. Đổi lại cam kết này, Zoom đồng ý duy trì mức giá hiện tại của Khách hàng trong suốt thời hạn gia hạn mới đầu tiên.",
      "content2": "Khách hàng hiểu rằng thời hạn gia hạn mới là {0} sẽ áp dụng ngay khi Khách hàng nhấp “Tôi chấp nhận” bên dưới, và thời hạn gia hạn mới sẽ bắt đầu vào ngày sau khi thời hạn gia hạn theo tháng hiện tại của Khách hàng kết thúc. Thời hạn gia hạn mới này sẽ áp dụng cho tất cả Biểu mẫu đơn hàng hiện đang có hiệu lực với Zoom, và tất cả các thời hạn gia hạn trong tương lai theo các Biểu mẫu đơn hàng này sẽ có cùng độ dài.",
      "content3": "Khách hàng xác nhận rằng thay đổi duy nhất được thực hiện là đối với thời hạn gia hạn, và tất cả các điều khoản và điều kiện khác của từng Biểu mẫu đơn hàng hiện đang có hiệu lực với Zoom vẫn không thay đổi và tiếp tục có đầy đủ hiệu lực theo các điều khoản của chúng.",
      "content4": "Bạn cũng đồng ý rằng đây là cam kết theo hợp đồng giữa Khách hàng và Zoom.",
      "agreementText": "Bằng việc nhấp “Tôi chấp nhận”, bạn xác nhận rằng bạn được ủy quyền thực hiện thay đổi này nhân danh Khách hàng, và rằng Khách hàng đồng ý với các điều khoản và điều kiện nêu trên.",
      "IDecline": "Tôi từ chối",
      "IAccept": "Tôi chấp nhận"
    },
    "unableToChangeTerm": {
      "title": "Không thể thay đổi thời hạn gia hạn",
      "content": "Tài khoản của bạn không đủ điều kiện để cập nhật thời hạn gia hạn. <a target=\"_blank\" href=\"{0}\">Liên hệ với chúng tôi</a> nếu đây là lỗi.",
      "acceptedTitle": "Đã gia hạn thời hạn gia hạn",
      "acceptedContent": "Bạn đã chấp nhận các điều khoản gia hạn trước đó. Không cần thực hiện thêm hành động nào.",
      "GotIt": "Đã hiểu"
    },
    "termLengthUpdated": "Độ dài thời hạn gia hạn đã được cập nhật thành {0} tháng.",
    "termLengthUnchanged": "Độ dài thời hạn không thay đổi.",
    "errorInfo": "Đã xảy ra lỗi máy chủ. Hãy thử lại.",
    "x12MonthTerm": "thời hạn mười hai (12) tháng",
    "x24MonthTerm": "thời hạn hai mươi bốn (24) tháng",
    "x12MonthTermPlural": "mười hai (12) tháng",
    "x24MonthTermPlural": "hai mươi bốn (24) tháng"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Tài khoản của bạn được lên lịch cập nhật lên <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">trải nghiệm web Zoom mới</a> vào {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Xem thời điểm cập nhật</a>"
    },
    "completed": {
      "content": "Trải nghiệm web Zoom mới hiện đã được kích hoạt cho tất cả người dùng trên tài khoản của bạn. Người dùng sẽ thấy giao diện đã cập nhật vào lần đăng nhập tiếp theo."
    }
  }
}
